import { gospelTerms } from './gospelTerms'

/**
 * Preload images for gospel terms found in the given text
 * This helps ensure smooth page transitions by loading images before they're needed
 * Looks for terms in the format (!term-name) in the lyrics
 */
export const preloadGospelTermImages = (text: string): void => {
	// Find all gospel term references in the format (!term-name)
	const termMatches = text.match(/\(!([^)]+)\)/g) || []

	// Extract term names and filter to only existing terms
	const foundTerms = termMatches
		.map(match => match.replace(/\(!([^)]+)\)/, '$1'))
		.filter(term => gospelTerms[term])

	// Remove duplicates
	const uniqueTerms = [...new Set(foundTerms)]

	// Preload images for found terms
	uniqueTerms.forEach(term => {
		const gospelTerm = gospelTerms[term]
		if (gospelTerm?.src) {
			preloadImage(gospelTerm.src)
		}
	})

	console.log(`Preloading ${uniqueTerms.length} gospel term images for upcoming pages`)
}

/**
 * Preload a single image by creating an Image object
 */
const preloadImage = (src: string): void => {
	const img = new Image()
	img.onload = () => {
		console.log(`Preloaded image: ${src}`)
	}
	img.onerror = () => {
		console.warn(`Failed to preload image: ${src}`)
	}
	img.src = src
}
